import React from 'react';
import autoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';
import AddIcon from 'material-ui/svg-icons/content/add-box';
import Field from '../../../components/Field';
import FieldLocation from '../../../components/FieldLocation';
import { PointInstructions } from '../../../components/Instructions';
import { PanelContainer, Panel } from '../../../components/Panel';
import noty from '../../../lib/noty';
import { MapPortal } from '../../../components/Map';
import MapEditPoint from '../MapEditPoint';
export default class EditFacility extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      panelOpen: true,
      fetching: false,
      touched: false,
      facility: this.props.facility
    };
  }

  handlePanelToggle() {
    this.setState({ panelOpen: !this.state.panelOpen });
  }

  handleChange({ name, value }) {
    const path = name.split('.');
    this.setState({
      touched: true,
      facility: this.state.facility.setIn(path, value)
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { facility } = this.state;
    this.setState({ fetching: true });
    facility
      .patch()
      .then(patched => {
        this.setState({ fetching: false, touched: false });
        noty.success('Facility updated.');
      })
      .catch(err => {
        this.setState({ fetching: false });
        noty.errors(err);
      });
  }

  render() {
    const { facility, fetching, touched } = this.state;
    return (
      <div>
        <PanelContainer
          width={475}
          open={this.state.panelOpen}
          onToggle={this.handlePanelToggle}
        >
          <Panel
            onSaveClick={this.handleSubmit}
            saveTitle="Save Facility"
            onDeleteClick={this.handleRemove}
            onCopyClick={this.handleRemove}
            fetching={fetching}
            touched={touched}
            touchedMessage="Are you sure that you want to leave? This facility has unsaved changes."
          >
            <div>
              <div className="row">
                <div className="col-xs-8">
                  <Field
                    name="name"
                    value={facility.name}
                    onChange={this.handleChange}
                    label="Facility Name"
                    disabled={fetching}
                  />
                </div>
                <div className="col-xs-4">
                  <Field
                    name="short_name"
                    value={facility.short_name}
                    onChange={this.handleChange}
                    hintText="GA"
                    label="Short Name"
                    disabled={fetching}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <FieldLocation
                    addressName="address"
                    geoValue={facility.geo.coordinates}
                    geoName="geo.coordinates"
                    value={facility.address}
                    onChange={this.handleChange}
                    label="Facility Location"
                    disabled={fetching}
                  />
                </div>
              </div>
              <PointInstructions />
            </div>
          </Panel>
          <div style={{ marginTop: 16 }}>
            <Paper>
              <div className="panel-container panel">
                <div className="row middle-xs">
                  <div className="col-xs-12 col-sm-6">
                    <p className="text-muted">
                      {facility.buildings().size} buildings in {facility.name}.
                    </p>
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <FlatButton
                      icon={<AddIcon />}
                      primary
                      style={{ float: 'right' }}
                      label="New Building"
                      containerElement={
                        <Link to={`/facilities/${facility._id}/buildings`} />
                      }
                      disabled={fetching}
                    />
                  </div>
                </div>
              </div>
            </Paper>
          </div>
        </PanelContainer>
        <MapPortal center={facility.geo.coordinates}>
          <MapEditPoint
            center={facility.geo.coordinates}
            onMarkerLocationChange={coords =>
              this.handleChange({
                name: 'geo.coordinates',
                value: coords
              })
            }
          />
        </MapPortal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Facility/EditFacility/index.jsx